import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ModalWindow, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatMessageMenu.css';
import { TChatMessageMenuItem } from '../../types/chatMessageMenuItem';

interface IChatMessageMenuProps {
  menuItems: TChatMessageMenuItem[];
  onShow(): void;
  onClose(): void;
  chatId: string;
  messageId: string;
}

export const ChatMessageMenu: React.FC<IChatMessageMenuProps> = ({ onShow, onClose, menuItems, chatId, messageId }) => {
  const items = React.useMemo(
    () =>
      menuItems.map(({ title, color, icon, handler }, index) => (
        <li
          key={`chat-message-menu-${index}`}
          className={styles['item']}
          style={{ color }}
          onClick={() => {
            onClose();
            handler(chatId, messageId);
          }}
        >
          {icon}
          <UIText1 color="current_color">{title}</UIText1>
        </li>
      )),
    [menuItems, onClose, chatId, messageId],
  );

  return (
    <ModalWindow open={true} onClose={onClose} fixed>
      <ActionAfterViewObserver callback={onShow} triggerOnce={false}>
        <ul className={styles['container']} data-name="ChatMessageMenu_list">
          {items}
        </ul>
      </ActionAfterViewObserver>
    </ModalWindow>
  );
};
